import PredictionTable from '@app.feature/exam/gsat2024-2/components/Table/PredictionTable'
import { TableColumnType } from '@app.feature/exam/gsat2024-2/components/Table/PredictionTableHead'
import {
  LevelRatingTableProps,
  TableDataType,
} from '@app.feature/exam/gsat2024-2/types/levelRatingType'

export interface LevelRatingTableDesktopProps extends LevelRatingTableProps {}

const LevelRatingTableDesktop = ({
  tableDataList,
}: LevelRatingTableDesktopProps) => {
  const columns: TableColumnType<TableDataType>[] = [
    { id: 'data', label: '항목', dataIndex: 'name' },
    { id: 'percent', label: '투표율(%)', dataIndex: 'dataText' },
  ]

  return (
    <PredictionTable<TableDataType>
      tableColumns={columns}
      tableDataList={tableDataList}
    />
  )
}

export default LevelRatingTableDesktop
